import React from "react";
import LessonInstruction from "../../containers/instruction/LessonInstruction";
import styles from "./ImageSubtitle.module.css";
import {getImageUrl} from "../../lib/utils";

const ImageSubtitle = ({ blockData, contentIndex, audioUrl }) => {

  // Verificações para evitar erro de acesso a propriedades indefinidas
  if (!blockData || !blockData.content || !blockData.content[contentIndex]) {
    console.error("blockData, blockData.content, or blockData.content[contentIndex] is missing:", blockData, contentIndex);
    return null;
  }

  const content = blockData.content[contentIndex];
  if (!content || !content.type) {
    console.error("content or content.type is missing:", content);
    return null;
  }

  return (
    <div className={`new-bg-color ${styles.imageSubtitle}`}>
      {content.type === "instruction" ? (
        <LessonInstruction
          instructionText={content.instruction}
          audioUrl={audioUrl} // Passando o áudio correto para a instrução
        />
      ) : (
        <div className={styles.contentContainer}>
          <div className={styles.title}>
            {blockData.complement && blockData.complement.titulo}
          </div>
          {blockData.complement &&
            blockData.complement.image &&
            blockData.complement.image.img && (
              <img
                alt="Subtitle"
                className={styles.image}
                src={getImageUrl(blockData.complement.image.img)}
              />
            )}
          <div className={styles.textContent}>
            <p>{content.en}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageSubtitle;
